import React, {useEffect, useMemo, useRef} from "react";

import {connect} from "react-redux";

import * as THREE from 'three'
import vertexShader from "../../../shader/Grid/vertexShader";
import fragmentShader from "../../../shader/Grid/fragmentShader";


/**
 * @description create tooth function. In order to batch creation tooth
 * @param props The parameter passed by the attribute within the tag
 * */
function CollisionAreaModel(props) {
    const { vertices, visible = true, } = props;

    const geometry = useMemo(() => {
        const geo = new THREE.BufferGeometry();
        geo.setAttribute('position', new THREE.BufferAttribute(vertices, 3));
        return geo;
    }, [vertices]);

    return (
        <group 
            visible={visible}
        >
            <lineSegments renderOrder={2} geometry={geometry}>
                <lineBasicMaterial
                    color={'#ff6666'}
                    depthWrite={false}
                    linewidth={2.0}
                    depthTest={false}
                    transparent={true} />
            </lineSegments>
            {/* <lineSegments
                ref={lineRef}
                renderOrder={2}
            >
                <bufferGeometry>
                    <bufferAttribute
                        attach="attributes-position"
                        array={vertices}
                        count={vertices.length / 3}
                        itemSize={3}
                        // needsUpdate={true}
                    />
                    <bufferAttribute
                            attach="attributes-index"
                            array={indexArr}
                            count={indexArr.length} //
                        />
                </bufferGeometry>
                <lineBasicMaterial
                    color={'#ff6666'}
                    depthWrite={false}
                    linewidth={2.0}
                    depthTest={false}
                    transparent={true} />
            </lineSegments> */}
        </group>
    )
}

export default CollisionAreaModel
